import { useMutation } from '@apollo/client/react';
import { TRACK_EVENT_MUTATION } from '../../graphql/event-mutations';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import CookieService from '../../services/cookie.service';

export default function useMutateTrackEvent() {
    const uuid = CookieService.get(COOKIE_PARAM_NAME.SESSION_UUID);
    const [mutateTrackEvent] = useMutation(TRACK_EVENT_MUTATION);

    const trackEvent = async ({ name, properties = {} }) => {
        await mutateTrackEvent({
            variables: {
                name,
                uuid,
                properties: JSON.stringify(properties),
            },
        });
    };

    return { trackEvent };
}
